/* eslint-disable @typescript-eslint/ban-ts-comment */

/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../types/__generated__/graphql"
import { HealthFragmentDoc } from "../health/fragments.generated"
import {
  ArticleNumberSearchResultsFragmentDoc,
  FloorPriceFragmentDoc,
  ProductPriceFragmentDoc,
  ProjectPriceFragmentDoc,
  RoomPriceFragmentDoc
} from "./fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
const defaultOptions = {} as const
export type ProjectPriceQueryVariables = Exact<{
  id: string
}>

export type ProjectPriceQuery = {
  __typename: "Query"
  projectPrice?: {
    __typename: "ProjectPrice"
    id: string
    priceTotal: number
    isComplete: boolean
    isValid?: boolean | null
    currency: string
    groups?: Array<{
      __typename: "PriceGroup"
      name: string
      priceTotal: number
      isComplete?: boolean | null
      parentPriceGroup: string
      groupType: string
    }> | null
  } | null
}

export type ArticleNumberSearchResultsQueryVariables = Exact<{
  mnr: string
}>

export type ArticleNumberSearchResultsQuery = {
  __typename: "Query"
  articleNumberSearchResults?: {
    __typename: "ArticleNumberSearchResults"
    id: string
    variantKey?: string | null
  } | null
}

export type RoomPriceQueryVariables = Exact<{
  id: string
}>

export type RoomPriceQuery = {
  __typename: "Query"
  roomPrice?: {
    __typename: "RoomPrice"
    id: string
    priceTotal: number
    isComplete: boolean
    isValid?: boolean | null
    currency: string
  } | null
}

export type FloorPriceQueryVariables = Exact<{
  id: string
}>

export type FloorPriceQuery = {
  __typename: "Query"
  floorPrice?: {
    __typename: "FloorPrice"
    id: string
    priceTotal: number
    isComplete: boolean
    isValid?: boolean | null
    currency: string
  } | null
}

export type ProductPositionPriceQueryVariables = Exact<{
  id: string
}>

export type ProductPositionPriceQuery = {
  __typename: "Query"
  productPositionPrice?: {
    __typename: "ProductPrice"
    id: string
    itemPrice: number
    priceTotal: number
    isComplete: boolean
    isValid?: boolean | null
    currency: string
    groups?: Array<{
      __typename: "PriceGroup"
      name: string
      priceTotal: number
      isComplete?: boolean | null
      parentPriceGroup: string
      groupType: string
    }> | null
  } | null
}

export type ProductPriceQueryVariables = Exact<{
  variantKey: string
  configurationKey?: string | null
}>

export type ProductPriceQuery = {
  __typename: "Query"
  productPrice?: {
    __typename: "ProductPrice"
    id: string
    itemPrice: number
    priceTotal: number
    isComplete: boolean
    isValid?: boolean | null
    currency: string
    groups?: Array<{
      __typename: "PriceGroup"
      name: string
      priceTotal: number
      isComplete?: boolean | null
      parentPriceGroup: string
      groupType: string
    }> | null
  } | null
}

export type SharedProjectPriceQueryVariables = Exact<{
  id: string
}>

export type SharedProjectPriceQuery = {
  __typename: "Query"
  sharedProjectPrice?: {
    __typename: "ProjectPrice"
    id: string
    priceTotal: number
    isComplete: boolean
    isValid?: boolean | null
    currency: string
    groups?: Array<{
      __typename: "PriceGroup"
      name: string
      priceTotal: number
      isComplete?: boolean | null
      parentPriceGroup: string
      groupType: string
    }> | null
  } | null
}

export type SharedRoomPriceQueryVariables = Exact<{
  projectShareID: string
  roomID: string
}>

export type SharedRoomPriceQuery = {
  __typename: "Query"
  sharedRoomPrice?: {
    __typename: "RoomPrice"
    id: string
    priceTotal: number
    isComplete: boolean
    isValid?: boolean | null
    currency: string
  } | null
}

export type SharedFloorPriceQueryVariables = Exact<{
  projectShareID: string
  floorID: string
}>

export type SharedFloorPriceQuery = {
  __typename: "Query"
  sharedFloorPrice?: {
    __typename: "FloorPrice"
    id: string
    priceTotal: number
    isComplete: boolean
    isValid?: boolean | null
    currency: string
  } | null
}

export type SharedProductPositionPriceQueryVariables = Exact<{
  projectShareID: string
  productPositionID: string
}>

export type SharedProductPositionPriceQuery = {
  __typename: "Query"
  sharedProductPositionPrice?: {
    __typename: "ProductPrice"
    id: string
    itemPrice: number
    priceTotal: number
    isComplete: boolean
    isValid?: boolean | null
    currency: string
    groups?: Array<{
      __typename: "PriceGroup"
      name: string
      priceTotal: number
      isComplete?: boolean | null
      parentPriceGroup: string
      groupType: string
    }> | null
  } | null
}

export type PriceHealthQueryVariables = Exact<{ [key: string]: never }>

export type PriceHealthQuery = {
  __typename: "Query"
  priceHealth?: { __typename: "Health"; isAvailable: boolean } | null
}

export const ProjectPriceDocument = gql`
  query ProjectPrice($id: ID!) {
    projectPrice(id: $id)
      @rest(
        type: "ProjectPrice"
        endpoint: "price"
        path: "/project-list/prices/projects/{args.id}"
      ) {
      ...ProjectPrice
    }
  }
  ${ProjectPriceFragmentDoc}
`

/**
 * __useProjectPriceQuery__
 *
 * To run a query within a React component, call `useProjectPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectPriceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProjectPriceQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProjectPriceQuery,
    ProjectPriceQueryVariables
  > &
    (
      | { variables: ProjectPriceQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProjectPriceQuery, ProjectPriceQueryVariables>(
    ProjectPriceDocument,
    options
  )
}
export function useProjectPriceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProjectPriceQuery,
    ProjectPriceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProjectPriceQuery, ProjectPriceQueryVariables>(
    ProjectPriceDocument,
    options
  )
}
// @ts-ignore
export function useProjectPriceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProjectPriceQuery,
    ProjectPriceQueryVariables
  >
): Apollo.UseSuspenseQueryResult<ProjectPriceQuery, ProjectPriceQueryVariables>
export function useProjectPriceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectPriceQuery,
        ProjectPriceQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ProjectPriceQuery | undefined,
  ProjectPriceQueryVariables
>
export function useProjectPriceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectPriceQuery,
        ProjectPriceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ProjectPriceQuery, ProjectPriceQueryVariables>(
    ProjectPriceDocument,
    options
  )
}
export type ProjectPriceQueryHookResult = ReturnType<
  typeof useProjectPriceQuery
>
export type ProjectPriceLazyQueryHookResult = ReturnType<
  typeof useProjectPriceLazyQuery
>
export type ProjectPriceSuspenseQueryHookResult = ReturnType<
  typeof useProjectPriceSuspenseQuery
>
export type ProjectPriceQueryResult = Apollo.QueryResult<
  ProjectPriceQuery,
  ProjectPriceQueryVariables
>
export const ArticleNumberSearchResultsDocument = gql`
  query ArticleNumberSearchResults($mnr: String!) {
    articleNumberSearchResults(mnr: $mnr)
      @rest(
        type: "ArticleNumberSearchResults"
        path: "/price/products/article-numbers?mnr={args.mnr}"
      ) {
      ...ArticleNumberSearchResults
    }
  }
  ${ArticleNumberSearchResultsFragmentDoc}
`

/**
 * __useArticleNumberSearchResultsQuery__
 *
 * To run a query within a React component, call `useArticleNumberSearchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleNumberSearchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleNumberSearchResultsQuery({
 *   variables: {
 *      mnr: // value for 'mnr'
 *   },
 * });
 */
export function useArticleNumberSearchResultsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ArticleNumberSearchResultsQuery,
    ArticleNumberSearchResultsQueryVariables
  > &
    (
      | { variables: ArticleNumberSearchResultsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ArticleNumberSearchResultsQuery,
    ArticleNumberSearchResultsQueryVariables
  >(ArticleNumberSearchResultsDocument, options)
}
export function useArticleNumberSearchResultsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ArticleNumberSearchResultsQuery,
    ArticleNumberSearchResultsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ArticleNumberSearchResultsQuery,
    ArticleNumberSearchResultsQueryVariables
  >(ArticleNumberSearchResultsDocument, options)
}
// @ts-ignore
export function useArticleNumberSearchResultsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ArticleNumberSearchResultsQuery,
    ArticleNumberSearchResultsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ArticleNumberSearchResultsQuery,
  ArticleNumberSearchResultsQueryVariables
>
export function useArticleNumberSearchResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ArticleNumberSearchResultsQuery,
        ArticleNumberSearchResultsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ArticleNumberSearchResultsQuery | undefined,
  ArticleNumberSearchResultsQueryVariables
>
export function useArticleNumberSearchResultsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ArticleNumberSearchResultsQuery,
        ArticleNumberSearchResultsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ArticleNumberSearchResultsQuery,
    ArticleNumberSearchResultsQueryVariables
  >(ArticleNumberSearchResultsDocument, options)
}
export type ArticleNumberSearchResultsQueryHookResult = ReturnType<
  typeof useArticleNumberSearchResultsQuery
>
export type ArticleNumberSearchResultsLazyQueryHookResult = ReturnType<
  typeof useArticleNumberSearchResultsLazyQuery
>
export type ArticleNumberSearchResultsSuspenseQueryHookResult = ReturnType<
  typeof useArticleNumberSearchResultsSuspenseQuery
>
export type ArticleNumberSearchResultsQueryResult = Apollo.QueryResult<
  ArticleNumberSearchResultsQuery,
  ArticleNumberSearchResultsQueryVariables
>
export const RoomPriceDocument = gql`
  query RoomPrice($id: ID!) {
    roomPrice(id: $id)
      @rest(
        type: "RoomPrice"
        endpoint: "price"
        path: "/project-list/prices/rooms/{args.id}"
      ) {
      ...RoomPrice
    }
  }
  ${RoomPriceFragmentDoc}
`

/**
 * __useRoomPriceQuery__
 *
 * To run a query within a React component, call `useRoomPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useRoomPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomPriceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRoomPriceQuery(
  baseOptions: Apollo.QueryHookOptions<
    RoomPriceQuery,
    RoomPriceQueryVariables
  > &
    ({ variables: RoomPriceQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<RoomPriceQuery, RoomPriceQueryVariables>(
    RoomPriceDocument,
    options
  )
}
export function useRoomPriceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RoomPriceQuery,
    RoomPriceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<RoomPriceQuery, RoomPriceQueryVariables>(
    RoomPriceDocument,
    options
  )
}
// @ts-ignore
export function useRoomPriceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RoomPriceQuery,
    RoomPriceQueryVariables
  >
): Apollo.UseSuspenseQueryResult<RoomPriceQuery, RoomPriceQueryVariables>
export function useRoomPriceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RoomPriceQuery, RoomPriceQueryVariables>
): Apollo.UseSuspenseQueryResult<
  RoomPriceQuery | undefined,
  RoomPriceQueryVariables
>
export function useRoomPriceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<RoomPriceQuery, RoomPriceQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<RoomPriceQuery, RoomPriceQueryVariables>(
    RoomPriceDocument,
    options
  )
}
export type RoomPriceQueryHookResult = ReturnType<typeof useRoomPriceQuery>
export type RoomPriceLazyQueryHookResult = ReturnType<
  typeof useRoomPriceLazyQuery
>
export type RoomPriceSuspenseQueryHookResult = ReturnType<
  typeof useRoomPriceSuspenseQuery
>
export type RoomPriceQueryResult = Apollo.QueryResult<
  RoomPriceQuery,
  RoomPriceQueryVariables
>
export const FloorPriceDocument = gql`
  query FloorPrice($id: ID!) {
    floorPrice(id: $id)
      @rest(
        type: "FloorPrice"
        endpoint: "price"
        path: "/project-list/prices/floors/{args.id}"
      ) {
      ...FloorPrice
    }
  }
  ${FloorPriceFragmentDoc}
`

/**
 * __useFloorPriceQuery__
 *
 * To run a query within a React component, call `useFloorPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useFloorPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFloorPriceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFloorPriceQuery(
  baseOptions: Apollo.QueryHookOptions<
    FloorPriceQuery,
    FloorPriceQueryVariables
  > &
    (
      | { variables: FloorPriceQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<FloorPriceQuery, FloorPriceQueryVariables>(
    FloorPriceDocument,
    options
  )
}
export function useFloorPriceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FloorPriceQuery,
    FloorPriceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<FloorPriceQuery, FloorPriceQueryVariables>(
    FloorPriceDocument,
    options
  )
}
// @ts-ignore
export function useFloorPriceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    FloorPriceQuery,
    FloorPriceQueryVariables
  >
): Apollo.UseSuspenseQueryResult<FloorPriceQuery, FloorPriceQueryVariables>
export function useFloorPriceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FloorPriceQuery, FloorPriceQueryVariables>
): Apollo.UseSuspenseQueryResult<
  FloorPriceQuery | undefined,
  FloorPriceQueryVariables
>
export function useFloorPriceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<FloorPriceQuery, FloorPriceQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<FloorPriceQuery, FloorPriceQueryVariables>(
    FloorPriceDocument,
    options
  )
}
export type FloorPriceQueryHookResult = ReturnType<typeof useFloorPriceQuery>
export type FloorPriceLazyQueryHookResult = ReturnType<
  typeof useFloorPriceLazyQuery
>
export type FloorPriceSuspenseQueryHookResult = ReturnType<
  typeof useFloorPriceSuspenseQuery
>
export type FloorPriceQueryResult = Apollo.QueryResult<
  FloorPriceQuery,
  FloorPriceQueryVariables
>
export const ProductPositionPriceDocument = gql`
  query ProductPositionPrice($id: ID!) {
    productPositionPrice(id: $id)
      @rest(
        type: "ProductPrice"
        endpoint: "price"
        path: "/project-list/prices/project-positions/{args.id}"
      ) {
      ...ProductPrice
    }
  }
  ${ProductPriceFragmentDoc}
`

/**
 * __useProductPositionPriceQuery__
 *
 * To run a query within a React component, call `useProductPositionPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPositionPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPositionPriceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductPositionPriceQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProductPositionPriceQuery,
    ProductPositionPriceQueryVariables
  > &
    (
      | { variables: ProductPositionPriceQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ProductPositionPriceQuery,
    ProductPositionPriceQueryVariables
  >(ProductPositionPriceDocument, options)
}
export function useProductPositionPriceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductPositionPriceQuery,
    ProductPositionPriceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProductPositionPriceQuery,
    ProductPositionPriceQueryVariables
  >(ProductPositionPriceDocument, options)
}
// @ts-ignore
export function useProductPositionPriceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProductPositionPriceQuery,
    ProductPositionPriceQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ProductPositionPriceQuery,
  ProductPositionPriceQueryVariables
>
export function useProductPositionPriceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProductPositionPriceQuery,
        ProductPositionPriceQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ProductPositionPriceQuery | undefined,
  ProductPositionPriceQueryVariables
>
export function useProductPositionPriceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProductPositionPriceQuery,
        ProductPositionPriceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ProductPositionPriceQuery,
    ProductPositionPriceQueryVariables
  >(ProductPositionPriceDocument, options)
}
export type ProductPositionPriceQueryHookResult = ReturnType<
  typeof useProductPositionPriceQuery
>
export type ProductPositionPriceLazyQueryHookResult = ReturnType<
  typeof useProductPositionPriceLazyQuery
>
export type ProductPositionPriceSuspenseQueryHookResult = ReturnType<
  typeof useProductPositionPriceSuspenseQuery
>
export type ProductPositionPriceQueryResult = Apollo.QueryResult<
  ProductPositionPriceQuery,
  ProductPositionPriceQueryVariables
>
export const ProductPriceDocument = gql`
  query ProductPrice($variantKey: String!, $configurationKey: String) {
    productPrice(variantKey: $variantKey, configurationKey: $configurationKey)
      @rest(
        type: "ProductPrice"
        endpoint: "productPrice"
        path: "/price/products/{args.variantKey}?configurationKey={args.configurationKey}"
      ) {
      ...ProductPrice
    }
  }
  ${ProductPriceFragmentDoc}
`

/**
 * __useProductPriceQuery__
 *
 * To run a query within a React component, call `useProductPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPriceQuery({
 *   variables: {
 *      variantKey: // value for 'variantKey'
 *      configurationKey: // value for 'configurationKey'
 *   },
 * });
 */
export function useProductPriceQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProductPriceQuery,
    ProductPriceQueryVariables
  > &
    (
      | { variables: ProductPriceQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProductPriceQuery, ProductPriceQueryVariables>(
    ProductPriceDocument,
    options
  )
}
export function useProductPriceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductPriceQuery,
    ProductPriceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProductPriceQuery, ProductPriceQueryVariables>(
    ProductPriceDocument,
    options
  )
}
// @ts-ignore
export function useProductPriceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProductPriceQuery,
    ProductPriceQueryVariables
  >
): Apollo.UseSuspenseQueryResult<ProductPriceQuery, ProductPriceQueryVariables>
export function useProductPriceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProductPriceQuery,
        ProductPriceQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ProductPriceQuery | undefined,
  ProductPriceQueryVariables
>
export function useProductPriceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProductPriceQuery,
        ProductPriceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ProductPriceQuery, ProductPriceQueryVariables>(
    ProductPriceDocument,
    options
  )
}
export type ProductPriceQueryHookResult = ReturnType<
  typeof useProductPriceQuery
>
export type ProductPriceLazyQueryHookResult = ReturnType<
  typeof useProductPriceLazyQuery
>
export type ProductPriceSuspenseQueryHookResult = ReturnType<
  typeof useProductPriceSuspenseQuery
>
export type ProductPriceQueryResult = Apollo.QueryResult<
  ProductPriceQuery,
  ProductPriceQueryVariables
>
export const SharedProjectPriceDocument = gql`
  query SharedProjectPrice($id: ID!) {
    sharedProjectPrice(id: $id)
      @rest(
        type: "ProjectPrice"
        endpoint: "price"
        path: "/project-list/share-links/{args.id}/project/price"
      ) {
      ...ProjectPrice
    }
  }
  ${ProjectPriceFragmentDoc}
`

/**
 * __useSharedProjectPriceQuery__
 *
 * To run a query within a React component, call `useSharedProjectPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedProjectPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedProjectPriceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSharedProjectPriceQuery(
  baseOptions: Apollo.QueryHookOptions<
    SharedProjectPriceQuery,
    SharedProjectPriceQueryVariables
  > &
    (
      | { variables: SharedProjectPriceQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SharedProjectPriceQuery,
    SharedProjectPriceQueryVariables
  >(SharedProjectPriceDocument, options)
}
export function useSharedProjectPriceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SharedProjectPriceQuery,
    SharedProjectPriceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SharedProjectPriceQuery,
    SharedProjectPriceQueryVariables
  >(SharedProjectPriceDocument, options)
}
// @ts-ignore
export function useSharedProjectPriceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SharedProjectPriceQuery,
    SharedProjectPriceQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  SharedProjectPriceQuery,
  SharedProjectPriceQueryVariables
>
export function useSharedProjectPriceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SharedProjectPriceQuery,
        SharedProjectPriceQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  SharedProjectPriceQuery | undefined,
  SharedProjectPriceQueryVariables
>
export function useSharedProjectPriceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SharedProjectPriceQuery,
        SharedProjectPriceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SharedProjectPriceQuery,
    SharedProjectPriceQueryVariables
  >(SharedProjectPriceDocument, options)
}
export type SharedProjectPriceQueryHookResult = ReturnType<
  typeof useSharedProjectPriceQuery
>
export type SharedProjectPriceLazyQueryHookResult = ReturnType<
  typeof useSharedProjectPriceLazyQuery
>
export type SharedProjectPriceSuspenseQueryHookResult = ReturnType<
  typeof useSharedProjectPriceSuspenseQuery
>
export type SharedProjectPriceQueryResult = Apollo.QueryResult<
  SharedProjectPriceQuery,
  SharedProjectPriceQueryVariables
>
export const SharedRoomPriceDocument = gql`
  query SharedRoomPrice($projectShareID: ID!, $roomID: ID!) {
    sharedRoomPrice(projectShareID: $projectShareID, roomID: $roomID)
      @rest(
        type: "RoomPrice"
        endpoint: "price"
        path: "/project-list/share-links/{args.projectShareID}/rooms/{args.roomID}/price"
      ) {
      ...RoomPrice
    }
  }
  ${RoomPriceFragmentDoc}
`

/**
 * __useSharedRoomPriceQuery__
 *
 * To run a query within a React component, call `useSharedRoomPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedRoomPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedRoomPriceQuery({
 *   variables: {
 *      projectShareID: // value for 'projectShareID'
 *      roomID: // value for 'roomID'
 *   },
 * });
 */
export function useSharedRoomPriceQuery(
  baseOptions: Apollo.QueryHookOptions<
    SharedRoomPriceQuery,
    SharedRoomPriceQueryVariables
  > &
    (
      | { variables: SharedRoomPriceQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SharedRoomPriceQuery, SharedRoomPriceQueryVariables>(
    SharedRoomPriceDocument,
    options
  )
}
export function useSharedRoomPriceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SharedRoomPriceQuery,
    SharedRoomPriceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SharedRoomPriceQuery,
    SharedRoomPriceQueryVariables
  >(SharedRoomPriceDocument, options)
}
// @ts-ignore
export function useSharedRoomPriceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SharedRoomPriceQuery,
    SharedRoomPriceQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  SharedRoomPriceQuery,
  SharedRoomPriceQueryVariables
>
export function useSharedRoomPriceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SharedRoomPriceQuery,
        SharedRoomPriceQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  SharedRoomPriceQuery | undefined,
  SharedRoomPriceQueryVariables
>
export function useSharedRoomPriceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SharedRoomPriceQuery,
        SharedRoomPriceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SharedRoomPriceQuery,
    SharedRoomPriceQueryVariables
  >(SharedRoomPriceDocument, options)
}
export type SharedRoomPriceQueryHookResult = ReturnType<
  typeof useSharedRoomPriceQuery
>
export type SharedRoomPriceLazyQueryHookResult = ReturnType<
  typeof useSharedRoomPriceLazyQuery
>
export type SharedRoomPriceSuspenseQueryHookResult = ReturnType<
  typeof useSharedRoomPriceSuspenseQuery
>
export type SharedRoomPriceQueryResult = Apollo.QueryResult<
  SharedRoomPriceQuery,
  SharedRoomPriceQueryVariables
>
export const SharedFloorPriceDocument = gql`
  query SharedFloorPrice($projectShareID: ID!, $floorID: ID!) {
    sharedFloorPrice(projectShareID: $projectShareID, floorID: $floorID)
      @rest(
        type: "FloorPrice"
        endpoint: "price"
        path: "/project-list/share-links/{args.projectShareID}/floors/{args.floorID}/price"
      ) {
      ...FloorPrice
    }
  }
  ${FloorPriceFragmentDoc}
`

/**
 * __useSharedFloorPriceQuery__
 *
 * To run a query within a React component, call `useSharedFloorPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedFloorPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedFloorPriceQuery({
 *   variables: {
 *      projectShareID: // value for 'projectShareID'
 *      floorID: // value for 'floorID'
 *   },
 * });
 */
export function useSharedFloorPriceQuery(
  baseOptions: Apollo.QueryHookOptions<
    SharedFloorPriceQuery,
    SharedFloorPriceQueryVariables
  > &
    (
      | { variables: SharedFloorPriceQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<SharedFloorPriceQuery, SharedFloorPriceQueryVariables>(
    SharedFloorPriceDocument,
    options
  )
}
export function useSharedFloorPriceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SharedFloorPriceQuery,
    SharedFloorPriceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SharedFloorPriceQuery,
    SharedFloorPriceQueryVariables
  >(SharedFloorPriceDocument, options)
}
// @ts-ignore
export function useSharedFloorPriceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SharedFloorPriceQuery,
    SharedFloorPriceQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  SharedFloorPriceQuery,
  SharedFloorPriceQueryVariables
>
export function useSharedFloorPriceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SharedFloorPriceQuery,
        SharedFloorPriceQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  SharedFloorPriceQuery | undefined,
  SharedFloorPriceQueryVariables
>
export function useSharedFloorPriceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SharedFloorPriceQuery,
        SharedFloorPriceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SharedFloorPriceQuery,
    SharedFloorPriceQueryVariables
  >(SharedFloorPriceDocument, options)
}
export type SharedFloorPriceQueryHookResult = ReturnType<
  typeof useSharedFloorPriceQuery
>
export type SharedFloorPriceLazyQueryHookResult = ReturnType<
  typeof useSharedFloorPriceLazyQuery
>
export type SharedFloorPriceSuspenseQueryHookResult = ReturnType<
  typeof useSharedFloorPriceSuspenseQuery
>
export type SharedFloorPriceQueryResult = Apollo.QueryResult<
  SharedFloorPriceQuery,
  SharedFloorPriceQueryVariables
>
export const SharedProductPositionPriceDocument = gql`
  query SharedProductPositionPrice(
    $projectShareID: ID!
    $productPositionID: ID!
  ) {
    sharedProductPositionPrice(
      projectShareID: $projectShareID
      productPositionID: $productPositionID
    )
      @rest(
        type: "ProductPrice"
        endpoint: "price"
        path: "/project-list/share-links/{args.projectShareID}/project-positions/{args.productPositionID}/price"
      ) {
      ...ProductPrice
    }
  }
  ${ProductPriceFragmentDoc}
`

/**
 * __useSharedProductPositionPriceQuery__
 *
 * To run a query within a React component, call `useSharedProductPositionPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedProductPositionPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedProductPositionPriceQuery({
 *   variables: {
 *      projectShareID: // value for 'projectShareID'
 *      productPositionID: // value for 'productPositionID'
 *   },
 * });
 */
export function useSharedProductPositionPriceQuery(
  baseOptions: Apollo.QueryHookOptions<
    SharedProductPositionPriceQuery,
    SharedProductPositionPriceQueryVariables
  > &
    (
      | { variables: SharedProductPositionPriceQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SharedProductPositionPriceQuery,
    SharedProductPositionPriceQueryVariables
  >(SharedProductPositionPriceDocument, options)
}
export function useSharedProductPositionPriceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SharedProductPositionPriceQuery,
    SharedProductPositionPriceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SharedProductPositionPriceQuery,
    SharedProductPositionPriceQueryVariables
  >(SharedProductPositionPriceDocument, options)
}
// @ts-ignore
export function useSharedProductPositionPriceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SharedProductPositionPriceQuery,
    SharedProductPositionPriceQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  SharedProductPositionPriceQuery,
  SharedProductPositionPriceQueryVariables
>
export function useSharedProductPositionPriceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SharedProductPositionPriceQuery,
        SharedProductPositionPriceQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  SharedProductPositionPriceQuery | undefined,
  SharedProductPositionPriceQueryVariables
>
export function useSharedProductPositionPriceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SharedProductPositionPriceQuery,
        SharedProductPositionPriceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    SharedProductPositionPriceQuery,
    SharedProductPositionPriceQueryVariables
  >(SharedProductPositionPriceDocument, options)
}
export type SharedProductPositionPriceQueryHookResult = ReturnType<
  typeof useSharedProductPositionPriceQuery
>
export type SharedProductPositionPriceLazyQueryHookResult = ReturnType<
  typeof useSharedProductPositionPriceLazyQuery
>
export type SharedProductPositionPriceSuspenseQueryHookResult = ReturnType<
  typeof useSharedProductPositionPriceSuspenseQuery
>
export type SharedProductPositionPriceQueryResult = Apollo.QueryResult<
  SharedProductPositionPriceQuery,
  SharedProductPositionPriceQueryVariables
>
export const PriceHealthDocument = gql`
  query PriceHealth {
    priceHealth
      @rest(type: "Health", endpoint: "health", path: "/price/health") {
      ...Health
    }
  }
  ${HealthFragmentDoc}
`

/**
 * __usePriceHealthQuery__
 *
 * To run a query within a React component, call `usePriceHealthQuery` and pass it any options that fit your needs.
 * When your component renders, `usePriceHealthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePriceHealthQuery({
 *   variables: {
 *   },
 * });
 */
export function usePriceHealthQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PriceHealthQuery,
    PriceHealthQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PriceHealthQuery, PriceHealthQueryVariables>(
    PriceHealthDocument,
    options
  )
}
export function usePriceHealthLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PriceHealthQuery,
    PriceHealthQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PriceHealthQuery, PriceHealthQueryVariables>(
    PriceHealthDocument,
    options
  )
}
// @ts-ignore
export function usePriceHealthSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PriceHealthQuery,
    PriceHealthQueryVariables
  >
): Apollo.UseSuspenseQueryResult<PriceHealthQuery, PriceHealthQueryVariables>
export function usePriceHealthSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PriceHealthQuery,
        PriceHealthQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  PriceHealthQuery | undefined,
  PriceHealthQueryVariables
>
export function usePriceHealthSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PriceHealthQuery,
        PriceHealthQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<PriceHealthQuery, PriceHealthQueryVariables>(
    PriceHealthDocument,
    options
  )
}
export type PriceHealthQueryHookResult = ReturnType<typeof usePriceHealthQuery>
export type PriceHealthLazyQueryHookResult = ReturnType<
  typeof usePriceHealthLazyQuery
>
export type PriceHealthSuspenseQueryHookResult = ReturnType<
  typeof usePriceHealthSuspenseQuery
>
export type PriceHealthQueryResult = Apollo.QueryResult<
  PriceHealthQuery,
  PriceHealthQueryVariables
>
